module.exports = __webpack_public_path__ + "img/look.com.ua-9166.eebf7326.jpg";